import type { SVGProps } from 'react';

export const MaxSocialIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 100 100" fill="none" aria-hidden {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.757 0.262c27.536 0 49.129 22.335 49.129 49.885 0 27.55-22.279 49.343-48.865 49.343-9.435 0-14.007-1.328-21.371-6.543-.507-.357-1.2-.264-1.629.193-5.664 6.043-20.171 10.286-20.835 2.036 0-14.386-7.186-23.729-7.186-45.3C0 21.555 23.221.262 50.757.262Zm.772 24.55C38.464 24.126 28.264 33.197 26.014 47.383c-1.864 11.75 1.436 26.072 4.265 26.793 1.2.307 4.078-1.9 6.178-3.879.393-.371.993-.435 1.45-.15 3.272 2 6.972 3.5 11.05 3.714 13.414.7 25.3-9.8 26.007-23.214.7-13.414-10.021-25.142-23.435-25.842v.007Z"
    />
  </svg>
);
